// extracted by mini-css-extract-plugin
export default {"spin":"FullPageSpin_spin__Fgpnb"};